module.exports = __webpack_public_path__ + "a85a78ed0f1e6dfe770856efeb8ca3e4.svg";